import {DateOnlyInput} from '../components/DateOnlyInput';
import { useRef, useState } from "react";
import { api, ApiError } from "../api";
import { ErrorState } from "../ui/State";
export function LeaseAmendment({
  lease,
  onSaved,
}: {
  lease: any;
  onSaved: () => Promise<void>;
}) {
  const [error, setError] = useState<unknown>(),
    [busy, setBusy] = useState(false);
  const pending = useRef<any>(undefined),
    locked = useRef(false);
  const send = async () => {
    if (locked.current) return;
    locked.current = true;
    setBusy(true);
    setError(undefined);
    try {
      const r = await api<any>("/api/property-legal/leases/" + lease.id, {
        method: "PATCH",
        body: JSON.stringify(pending.current),
      });
      if (r.id !== lease.id || r.version <= lease.version)
        throw Error(
          "The save response could not be confirmed. Retry the same change.",
        );
      pending.current = undefined;
      await onSaved();
    } catch (e) {
      if (e instanceof ApiError && e.statusCode > 0 && e.statusCode < 500)
        pending.current = undefined;
      setError(e);
    } finally {
      locked.current = false;
      setBusy(false);
    }
  };
  return (
    <details>
      <summary>Amend or end this lease</summary>
      <p>
        The commencement, property links and historic parties are retained. Date
        changes must not overlap another lease of the same demise.
      </p>
      {Boolean(error) && <ErrorState error={error} />}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const f = new FormData(e.currentTarget);
          pending.current ??= {
            expectedVersion: lease.version,
            expiryDate: String(f.get("expiry")) || null,
            demiseDescription: String(f.get("description")),
            status: String(f.get("status")),
            sourceDocumentId: lease.source_document_id ?? null,
            reason: String(f.get("reason")),
            idempotencyKey: crypto.randomUUID(),
          };
          void send();
        }}
      >
        <fieldset disabled={busy || Boolean(pending.current)}>
          <label>
            End date
            <DateOnlyInput
              name="expiry"

              defaultValue={lease.expiry_date ?? ""}
            />
          </label>
          <label>
            Status
            <select aria-label="Status" name="status" defaultValue={lease.status}>
              {["Draft", "Current", "Disputed", "Ended"].map((v) => (
                <option key={v}>{v}</option>
              ))}
            </select>
          </label>
          <label>
            Demise description
            <textarea
              name="description"
              defaultValue={lease.demise_description ?? ""}
              maxLength={10000}
            />
          </label>

          <label>
            Reason
            <input name="reason" required minLength={3} maxLength={1000} />
          </label>
          <button>Save lease amendment</button>
        </fieldset>
      </form>
      {pending.current && !busy && (
        <button onClick={() => void send()}>Retry the same amendment</button>
      )}
    </details>
  );
}
